import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Capacitor } from '@capacitor/core';
import Landing from './Landing';

export default function Home() {
  const { user, loading } = useAuth();
  const isNativeApp = Capacitor.isNativePlatform();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="spinner"></div>
      </div>
    );
  }

  // Eingeloggt → zur Listen-Übersicht
  if (user) {
    return <Navigate to="/lists" replace />;
  }

  // Nicht eingeloggt im Browser → Landing Page
  if (!isNativeApp) {
    return <Landing />;
  }

  // Nicht eingeloggt in der App → Login
  return <Navigate to="/login" replace />;
}
